export enum UserRole {
    Empty = 'empty',
    Moderator = 'moderator',
}
